import { LicenseInfo } from "@mui/x-license";

export const setMuiLicenseKey = () => {
  LicenseInfo.setLicenseKey(
    //expires 17.11.2026
    "ad07fc83760c919d2f3dbb4344fb2d82Tz0xMjE5NDgsRT0xNzk1MDQ2Mzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y"
  );
};
